// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getContentSearchParameter } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import { getSearchQuery } from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListSelectors";

export const getContentSearchDataView = (state: ApplicationState) => {
    const query = getSearchQuery(state) || "";
    const contentSearchParameter = getContentSearchParameter(state);
    const { currentTab, ...parameter } = contentSearchParameter;

    return getDataView(state.data.pages, { ...parameter, query });
};
